import type { Achievement, AchievementId } from './types'

export const ACHIEVEMENT_ID_TO_DATA: Record<AchievementId, Achievement> = {
  welcome: {
    title: 'Welcome to Schoolhouse',
    subtitle: 'Approved to Join',
    iconActive: 'welcome-completed.svg',
    iconInactive: 'welcome-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 1,
    category: 'other',
    // ^ Non-zero points gets you this achievement
    // Since we give x points for getting approved, it'll
    // unlock this achievement
  },
  'attend-1': {
    title: 'New Kid in Class',
    subtitle: 'Attend 1 session',
    iconActive: 'learn-1-completed.svg',
    iconInactive: 'learn-1-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 1,
    category: 'attend',
  },
  'attend-5': {
    title: 'Explorer',
    subtitle: 'Attend 5 sessions',
    iconActive: 'learn-5-completed.svg',
    iconInactive: 'learn-5-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 5,
    category: 'attend',
  },
  'attend-10': {
    title: 'Voyager',
    subtitle: 'Attend 10 sessions',
    iconActive: 'learn-10-completed.svg',
    iconInactive: 'learn-10-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 10,
    category: 'attend',
  },
  'attend-25': {
    title: 'Out of This World',
    subtitle: 'Attend 25 sessions',
    iconActive: 'learn-25-completed.svg',
    iconInactive: 'learn-25-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 25,
    category: 'attend',
  },
  'attend-50': {
    title: 'Star Student',
    subtitle: 'Attend 50 sessions',
    iconActive: 'learn-50-completed.svg',
    iconInactive: 'learn-50-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 50,
    category: 'attend',
  },
  'attend-100': {
    title: 'Intergalactic',
    subtitle: 'Attend 100 sessions',
    iconActive: 'learn-100-completed.svg',
    iconInactive: 'learn-100-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 100,
    category: 'attend',
  },
  'attend-200': {
    title: 'Life, the Universe and Everything',
    subtitle: 'Attend 200 sessions',
    iconActive: 'learn-200-completed.svg',
    iconInactive: 'learn-200-not-completed.svg',
    criteriaKey: 'num_sessions_attended',
    criteriaValue: 200,
    category: 'attend',
  },
  'certify-1': {
    title: 'Show Your Stuff',
    subtitle: 'Get 1 certification',
    iconActive: 'certify-1-completed.svg',
    iconInactive: 'certify-1-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 1,
    category: 'certify',
  },
  'certify-5': {
    title: 'Thinker',
    subtitle: 'Get 5 certifications',
    iconActive: 'certify-5-completed.svg',
    iconInactive: 'certify-5-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 5,
    category: 'certify',
  },
  'certify-10': {
    title: 'Whiz Kid',
    subtitle: 'Get 10 certifications',
    iconActive: 'certify-10-completed.svg',
    iconInactive: 'certify-10-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 10,
    category: 'certify',
  },
  'certify-25': {
    title: 'Scholar',
    subtitle: 'Get 25 certifications',
    iconActive: 'certify-25-completed.svg',
    iconInactive: 'certify-25-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 25,
    category: 'certify',
  },
  'certify-50': {
    title: 'Sage',
    subtitle: 'Get 50 certifications',
    iconActive: 'certify-50-completed.svg',
    iconInactive: 'certify-50-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 50,
    category: 'certify',
  },
  'certify-100': {
    title: 'Big Brain',
    subtitle: 'Get 100 certifications',
    iconActive: 'certify-100-completed.svg',
    iconInactive: 'certify-100-not-completed.svg',
    criteriaKey: 'num_certifications_approved',
    criteriaValue: 100,
    category: 'certify',
  },
  'host-1': {
    title: 'Red Delicious',
    subtitle: 'Host 1 session',
    iconActive: 'tutor-1-completed.svg',
    iconInactive: 'tutor-1-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 1,
    category: 'host',
  },
  'host-5': {
    title: 'Granny Smith',
    subtitle: 'Host 5 sessions',
    iconActive: 'tutor-5-completed.svg',
    iconInactive: 'tutor-5-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 5,
    category: 'host',
  },
  'host-10': {
    title: 'Honeycrisp',
    subtitle: 'Host 10 sessions',
    iconActive: 'tutor-10-completed.svg',
    iconInactive: 'tutor-10-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 10,
    category: 'host',
  },
  'host-25': {
    title: 'Fuji',
    subtitle: 'Host 25 sessions',
    iconActive: 'tutor-25-completed.svg',
    iconInactive: 'tutor-25-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 25,
    category: 'host',
  },
  'host-50': {
    title: 'Pink Lady',
    subtitle: 'Host 50 sessions',
    iconActive: 'tutor-50-completed.svg',
    iconInactive: 'tutor-50-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 50,
    category: 'host',
  },
  'host-100': {
    title: 'Cosmic Crisp',
    subtitle: 'Host 100 sessions',
    iconActive: 'tutor-100-completed.svg',
    iconInactive: 'tutor-100-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 100,
    category: 'host',
  },
  'host-200': {
    title: 'Golden Delicious',
    subtitle: 'Host 200 sessions',
    iconActive: 'tutor-200-completed.svg',
    iconInactive: 'tutor-200-not-completed.svg',
    criteriaKey: 'num_sessions_hosted',
    criteriaValue: 200,
    category: 'host',
  },
  'refer-1': {
    title: 'Feeling Friendly',
    subtitle: 'Refer 1 friend',
    iconActive: 'refer-1-completed.svg',
    iconInactive: 'refer-1-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 1,
    category: 'refer',
  },
  'refer-5': {
    title: 'Best Buddies',
    subtitle: 'Refer 5 friends',
    iconActive: 'refer-5-completed.svg',
    iconInactive: 'refer-5-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 5,
    category: 'refer',
  },
  'refer-10': {
    title: 'Social Butterfly',
    subtitle: 'Refer 10 friends',
    iconActive: 'refer-10-completed.svg',
    iconInactive: 'refer-10-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 10,
    category: 'refer',
  },
  'refer-25': {
    title: 'Squad Goals',
    subtitle: 'Refer 25 friends',
    iconActive: 'refer-25-completed.svg',
    iconInactive: 'refer-25-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 25,
    category: 'refer',
  },
  'refer-50': {
    title: 'Popular Kid',
    subtitle: 'Refer 50 friends',
    iconActive: 'refer-50-completed.svg',
    iconInactive: 'refer-50-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 50,
    category: 'refer',
  },
  'refer-100': {
    title: 'Schoolhouse Celebrity',
    subtitle: 'Refer 100 friends',
    iconActive: 'refer-100-completed.svg',
    iconInactive: 'refer-100-not-completed.svg',
    criteriaKey: 'num_users_referred',
    criteriaValue: 100,
    category: 'refer',
  },
  'level-bronze': {
    title: 'Bronze Level',
    subtitle: 'Get 500 SP',
    iconActive: 'level-bronze-completed.svg',
    iconInactive: 'level-bronze-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 500,
    category: 'level',
  },
  'level-silver': {
    title: 'Silver Level',
    subtitle: 'Get 1000 SP',
    iconActive: 'level-silver-completed.svg',
    iconInactive: 'level-silver-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 1000,
    category: 'level',
  },
  'level-gold': {
    title: 'Gold Level',
    subtitle: 'Get 2500 SP',
    iconActive: 'level-gold-completed.svg',
    iconInactive: 'level-gold-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 2500,
    category: 'level',
  },
  'level-platinum': {
    title: 'Platinum Level',
    subtitle: 'Get 5000 SP',
    iconActive: 'level-platinum-completed.svg',
    iconInactive: 'level-platinum-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 5000,
    category: 'level',
  },
  'level-diamond': {
    title: 'Diamond Level',
    subtitle: 'Get 10000 SP',
    iconActive: 'level-diamond-completed.svg',
    iconInactive: 'level-diamond-not-completed.svg',
    criteriaKey: 'points',
    criteriaValue: 10000,
    category: 'level',
  },
  // Manually assigned
  'varun-birthday-2021': {
    title: 'King of Snow Day',
    subtitle: 'Happy birthday Varun!',
    iconActive: 'varun-birthday-2021.png',
    iconInactive: 'varun-birthday-2021.png',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
    link: 'https://www.youtube.com/watch?v=nJ2gR0Xbeh4',
  },
  'allaam-birthday-2022': {
    title: 'Master of Study Spaces',
    subtitle: 'Happy birthday Allaam!',
    iconActive: 'allaam-birthday-2022.png',
    iconInactive: 'allaam-birthday-2022.png',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
    link: 'https://youtu.be/-IzJZiDMOQw',
  },
  'external-partnership-tutor': {
    title: 'External Partnership Tutor',
    subtitle: 'Participated in an external partnership',
    iconActive: 'external-partnership-tutor.svg',
    iconInactive: 'external-partnership-tutor.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'kareena-birthday-2022': {
    title: 'Legend of Learning Circles',
    subtitle: 'Happy birthday Kareena!',
    iconActive: 'kareena-birthday-2022.png',
    iconInactive: 'kareena-birthday-2022.png',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2022': {
    title: "Camp Counselor '22",
    subtitle: 'Tutored for Summer Camp 2022',
    iconActive: 'summer-camp-22.svg',
    iconInactive: 'summer-camp-22.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2023-tutor': {
    title: "Camp Counselor '23",
    subtitle: 'Tutored for Summer Camp 2023',
    iconActive: 'summer-camp-23-tutor.svg',
    iconInactive: 'summer-camp-23-tutor.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2023-learner': {
    title: "Camper '23",
    subtitle: 'Participated in Summer Camp 2023',
    iconActive: 'summer-camp-23-learner.svg',
    iconInactive: 'summer-camp-23-learner.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2024-tutor': {
    title: "Camp Counselor '24",
    subtitle: 'Tutored for Summer Camp 2024',
    iconActive: 'summer-camp-24-tutor.svg',
    iconInactive: 'summer-camp-24-tutor.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2024-learner': {
    title: "Camper '24",
    subtitle: 'Participated in Summer Camp 2024',
    iconActive: 'summer-camp-24-learner.svg',
    iconInactive: 'summer-camp-24-learner.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2025-learner': {
    title: "Camper '25",
    subtitle: 'Participated in Summer Camp 2025',
    iconActive: 'summer-camp-25-learner.svg',
    iconInactive: 'summer-camp-25-learner.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'summer-camp-2025-tutor': {
    title: "Camp Counselor '25",
    subtitle: 'Tutored for Summer Camp 2025',
    iconActive: 'summer-camp-25-tutor.svg',
    iconInactive: 'summer-camp-25-tutor.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'ms-pilot-2023': {
    title: 'Middle School Program Tutor',
    subtitle: 'Participated in a 2023 Middle School Program',
    iconActive: 'ms-pilot-tutor.svg',
    iconInactive: 'ms-pilot-tutor.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'subworld-pioneer-tutor-2023': {
    title: 'Subworld Pioneer Tutor',
    subtitle: 'Participated in the Subworlds beta test',
    iconActive: 'subworld-pioneer-tutor.png',
    iconInactive: 'subworld-pioneer-tutor.png',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
  'sat-referral-march-2024': {
    title: 'March 2024 SAT Referrer',
    subtitle: 'Referred 5+ people to the March 2024 SAT Bootcamp',
    iconActive: 'refer-5-completed.svg',
    iconInactive: 'refer-5-completed.svg',
    category: 'one-off',
    criteriaKey: 'points',
    criteriaValue: 0,
  },
} as const
